import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20with%20flowing%20hair%20in%20an%20elegant%20dress%2C%20standing%20in%20a%20field%20of%20cherry%20blossoms%2C%20soft%20spring%20sunlight%2C%20pink%20petals%20dancing%20in%20the%20air%2C%20dreamy%20romantic%20atmosphere%2C%20cinematic%20wide%20angle%2C%20ethereal%20and%20artistic%20composition%2C%20warm%20pink%20cream%20and%20golden%20tones%2C%20soft%20focus%20background&width=1800&height=800&seq=hero-main-bg&orientation=landscape"
          alt="苍井樱"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <p className="text-sm md:text-base tracking-[0.3em] text-white/80 mb-4 font-light">
          苍井樱 · 官方中文资料站
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-semibold text-white mb-6 tracking-wide">
          <span className="text-primary-400">樱</span>之花语
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-xl leading-relaxed mb-8">
          全面了解苍井樱个人资料、经典作品回顾与最新动态，
          <br className="hidden md:block" />
          华语区最权威的苍井樱中文资讯平台
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/works"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            浏览作品集
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 text-white backdrop-blur-sm border border-white/20 rounded-full text-sm font-medium hover:bg-white/20 transition-all duration-200 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}